var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralHowItWorksStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 1.3,
    width: 98.4,
    height: 98.4,
    rx: 49.2,
    fill: "#373C44"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 1.3,
    width: 98.4,
    height: 98.4,
    rx: 49.2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 99.7246C77.731 99.7246 100 77.4556 100 50.2246C100 22.9502 77.731 0.724609 50.5 0.724609C23.2256 0.724609 1 22.9517 1 50.2246C1 77.4556 23.2271 99.7246 50.5 99.7246Z",
    fill: "#393E45",
    stroke: "black",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3774 26.979C78.9228 27.6584 79.7278 27.1062 81.3409 28.9722C83.8428 31.8138 83.8428 36.0979 83.1231 38.6432C81.7659 43.7339 75.5305 48.823 70.567 47.5077C65.6036 46.1505 63.5685 39.5336 64.5441 34.4429C64.586 34.1885 64.6294 33.9341 64.7132 33.7217C66.0704 28.6325 71.2868 25.5784 76.3774 26.979ZM65.2639 49.6715C67.1733 52.9381 71.3721 54.0828 74.6387 52.2168L76.8024 50.9449L77.9905 51.2412C81.1718 52.0896 82.1475 51.5809 83.6319 53.4887C85.5412 55.9907 85.2435 59.2573 84.6494 61.5482L82.0622 71.134L74.9364 69.2246L56.6553 64.3464L49.4023 62.3951L51.9477 52.8094C53.4321 47.3371 57.3765 45.7256 62.8487 47.21L64.0369 47.5062L65.2639 49.6715Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1183 53.0662L12.3254 43.9892C11.7313 42.8011 11.8166 40.4264 13.1319 38.5604L33.9584 30.0775C35.1885 29.5687 36.5876 29.9503 37.225 31.1384L41.9326 40.4279L42.3995 41.3182L43.5876 41.4454L35.6553 54.7212L17.1183 53.0662Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6896 41.571L49.1428 50.3936L54.2335 57.3922C54.5298 57.9862 53.7247 60.6153 53.0888 60.9131L40.1945 67.4882L27.3003 74.0632C27.004 74.1904 26.6209 74.2323 26.3247 74.1051C26.0284 74.0198 25.7306 73.8088 25.5615 73.4692L16.7793 56.5018L17.119 53.0661L35.6545 54.7211L43.5868 41.4453L44.6896 41.571Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.199 38.7715L49.6522 47.5941L54.1488 56.3748C54.3179 56.7145 54.3179 57.0542 54.2341 57.3923C54.1488 57.6886 53.8944 57.9445 53.5982 58.1136L40.7039 64.6887L27.8097 71.2203C27.5134 71.3894 27.1737 71.3894 26.834 71.3056C26.5378 71.2203 26.24 71.0093 26.1128 70.6697L17.1211 53.0663L34.1304 54.5926C35.0641 54.6779 35.9544 54.253 36.4213 53.4045L45.199 38.7715Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1991 38.7712L26.4091 36.6074L19.3672 53.277L34.1289 54.5923C35.0626 54.6776 35.953 54.2526 36.4198 53.4042L45.1991 38.7712Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1946 54.5059L26.832 71.3041",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0137 52.4277L54.2354 57.3912",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3653 53.276L34.127 54.5913C35.0607 54.6766 35.9511 54.2516 36.4179 53.4032L44.0524 40.7199L37.7317 28.2911C37.0958 27.103 35.6533 26.6361 34.4652 27.2301L14.1055 37.582C12.9174 38.218 12.4505 39.6605 13.0446 40.8486L19.3653 53.276Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5589 33.5961C33.958 34.063 35.019 35.0386 35.6549 36.2686C36.2909 37.4986 36.4181 38.9411 35.9946 40.3402L35.3153 42.4187C35.1881 42.715 34.8484 42.8856 34.5521 42.8003L33.0677 42.2915C32.7714 42.2062 32.5589 41.868 32.6861 41.5703L33.3655 39.4918C33.578 38.8124 33.4927 38.0927 33.1964 37.4986C32.9001 36.9046 32.3898 36.4377 31.712 36.2267C31.0326 36.0142 30.3129 36.0576 29.7188 36.3958C29.1248 36.6921 28.6579 37.2023 28.4469 37.8802L27.7675 39.9587C27.6823 40.2549 27.3441 40.4255 27.0044 40.3402L25.52 39.8734C25.2237 39.7462 25.0531 39.4065 25.1384 39.1102L25.8178 37.0318C26.2846 35.6326 27.2603 34.5298 28.4903 33.9358C29.7173 33.2983 31.1583 33.1292 32.5589 33.5961ZM32.0502 38.3456C31.8811 38.0059 31.5833 37.7515 31.2436 37.6243C30.862 37.539 30.4805 37.5824 30.1827 37.7096C29.8864 37.8787 29.6305 38.1765 29.5033 38.5162L27.3396 45.1331C27.2124 45.5147 27.2543 45.8963 27.4249 46.194C27.594 46.5337 27.8483 46.7881 28.2314 46.8734C28.5711 47.0006 28.9527 46.9587 29.2924 46.7881C29.5886 46.6609 29.8445 46.3646 29.9717 45.9816L32.1355 39.3646C32.2193 39.0249 32.1774 38.6433 32.0502 38.3456ZM34.3396 45.4294L33.6603 47.5079C33.1934 48.907 32.2178 49.9679 30.9877 50.6039C29.7577 51.2398 28.3152 51.367 26.9161 50.9435C25.517 50.4767 24.4142 49.501 23.8201 48.271C23.1842 47.041 23.0136 45.5985 23.4804 44.1994L24.1598 42.1209C24.2451 41.7812 24.5833 41.6122 24.9229 41.7393L26.4073 42.2062C26.7036 42.3334 26.8742 42.6731 26.7889 42.9694L26.1096 45.0478C25.8971 45.7272 25.9405 46.405 26.2787 46.9991C26.5749 47.5932 27.0852 48.1019 27.7631 48.3144C28.4424 48.5269 29.1203 48.4416 29.7143 48.1453C30.3084 47.849 30.8172 47.3388 31.0296 46.6609L31.709 44.5824C31.7943 44.2428 32.1325 44.0737 32.4721 44.2009L33.9565 44.6677C34.2558 44.7515 34.4249 45.0912 34.3396 45.4294Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8303 71.3047L26.7031 74.1882",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3932 59.2578L51.2227 62.1428",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6407 41.9941L13.4297 46.0239",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9946 44.7522L63.1827 45.0485L64.4128 47.2541C66.3221 50.5207 70.5209 51.6235 73.7875 49.7561L75.9513 48.4842L77.1394 48.8238C82.6116 50.2663 85.2408 53.6167 83.7983 59.0889L81.211 68.7181L48.5078 59.9374L51.095 50.3516C52.5779 44.8794 56.5239 43.2678 61.9946 44.7522Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.529 24.5187C70.4384 23.1615 65.222 26.1737 63.8648 31.2628C62.4657 36.3535 64.8404 44.0733 69.9311 45.4305C75.0217 46.7877 80.9175 41.2736 82.2747 36.1829C83.6304 31.0938 80.6182 25.8774 75.529 24.5187Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6934 31.9826C69.2075 33.2979 72.9828 33.892 77.9029 31.0923C77.9029 31.0923 78.5823 34.1464 82.2723 36.1829C83.6295 31.0923 80.6173 25.8759 75.5282 24.5187C70.4375 23.1615 65.2212 26.1737 63.8639 31.2628C63.7787 31.5172 63.7368 31.7282 63.6934 31.9826Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8008 61.8877L58.2174 52.8945",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0859 66.8096L76.5041 57.8164",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2109 68.7168L82.0594 71.1349",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0859 66.8086L74.9344 69.2267",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2715 36.1836C82.2715 36.1836 82.9927 38.6855 82.3987 40.553",
    stroke: "black",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2697 36.1837C82.2697 36.1837 82.9909 38.6856 82.3969 40.5531C82.7365 39.9171 82.949 39.2812 83.1181 38.6437C83.8394 36.0984 83.8394 31.8143 81.3359 28.9727C82.566 31.093 82.9475 33.6383 82.2697 36.1837Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3478 61.082C45.0271 61.082 39.8945 66.2146 39.8945 72.5353C39.8945 78.8559 45.0271 83.9885 51.3478 83.9885C57.6684 83.9885 62.801 78.8559 62.801 72.5353C62.801 66.2146 57.6684 61.082 51.3478 61.082Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3478 58.3691C45.0271 58.3691 39.8945 63.5017 39.8945 69.8224C39.8945 76.1431 45.0271 81.2756 51.3478 81.2756C57.6684 81.2756 62.801 76.1431 62.801 69.8224C62.801 63.5017 57.6684 58.3691 51.3478 58.3691Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5367 62.5664H50.162C49.4407 62.5664 48.8467 63.1605 48.8467 63.8817V67.3174H45.411C44.6898 67.3174 44.0957 67.9114 44.0957 68.6327V71.0074C44.0957 71.7287 44.6898 72.3228 45.411 72.3228H48.8467V75.7584C48.8467 76.4797 49.4407 77.0737 50.162 77.0737H52.5367C53.258 77.0737 53.8521 76.4797 53.8521 75.7584V72.3228H57.2877C58.009 72.3228 58.603 71.7287 58.603 71.0074V68.6327C58.603 67.9114 58.009 67.3174 57.2877 67.3174H53.8521V63.8817C53.8521 63.1605 53.258 62.5664 52.5367 62.5664Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7667 80.2969L46.5977 82.5444",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5191 20.7012C38.0713 20.1505 38.3676 19.938 39.0035 19.4293C41.6327 17.3927 45.197 15.7811 48.8871 15.2304C52.7043 14.6364 56.6488 15.1033 59.9572 17.3089C61.0601 18.0302 62.0776 18.9639 62.9694 20.1086L65.0898 17.6067C65.2589 17.4376 66.0654 19.6851 65.811 20.3645L63.3929 26.5146C63.2657 26.8109 62.926 26.9381 62.6298 26.769L57.37 23.248C56.7759 22.8664 56.2253 20.6608 56.4363 20.7027L59.1088 21.4239C58.6853 21.0424 58.2604 20.7027 57.8369 20.4064C55.3349 18.7514 52.2809 18.3698 49.3106 18.8367C46.2565 19.3455 43.2877 20.6608 41.1658 22.2724C40.657 22.6958 40.1902 23.0789 39.7667 23.5024C39.1726 24.0964 38.2823 24.1817 37.561 23.7568L36.8817 23.3752C36.4148 23.1208 36.3729 20.8733 36.3295 20.363C36.2891 19.8108 37.1376 21.0828 37.5191 20.7012Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8002 19.0048C37.3089 18.4527 37.903 17.9439 38.5389 17.4351C41.0843 15.3986 44.5618 13.787 48.2519 13.2363C51.9838 12.6422 55.9717 13.1091 59.3655 15.3148C60.6374 16.1213 61.8255 17.1807 62.8864 18.538L60.0014 20.7855C59.2383 19.8099 58.3464 19.0033 57.3723 18.4108C54.827 16.7558 51.7729 16.3742 48.8041 16.8411C45.75 17.3498 42.865 18.6651 40.788 20.2767C40.3211 20.7002 39.8543 21.0833 39.4727 21.5068C38.9205 22.1008 37.9883 22.228 37.267 21.7611L37.0979 21.6758C36.6745 21.3796 36.3767 20.9546 36.3348 20.4039C36.248 19.8967 36.4171 19.4298 36.8002 19.0048Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.033 21.2525L62.5053 24.7735C62.8016 24.9426 63.0993 24.8154 63.2265 24.5191L65.3469 18.369C65.4322 18.1565 65.3888 17.8603 65.2197 17.6059C65.0506 17.3934 64.8381 17.3096 64.5837 17.3934L57.033 19.9806C56.8206 20.0659 56.6934 20.2769 56.6934 20.5747C56.6934 20.8276 56.8206 21.0819 57.033 21.2525Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralHowItWorksStep1);
export default __webpack_public_path__ + "static/media/referral-how-it-works-step-1.314bcf96e980e2b3084dcf1f386f75db.svg";
export { ForwardRef as ReactComponent };